// Наставник обучения — персонаж мира, а не системное окно (BackEnd/docs/TUTORIAL_PLAN.md §3).
// Эльфам помогает Фанилуана, зомби — Бессмертная королева (решение оунера 2026-07-29): вместо эмодзи
// берём РЕАЛЬНЫЙ спрайт королевы фракции и кадрируем его «по грудь» — портрет вместо иконки.

export function mentorName(fraction) {
  return fraction === 'Zombie' ? 'tut.mentorZombie' : 'tut.mentorElf';
}

/** Портрет наставника: спрайт королевы своей фракции (кадрируется CSS — см. `mentorFace`). */
export function mentorPortrait(fraction) {
  return fraction === 'Zombie'
    ? '/game/figures/zombie_Queen_Archer_face.png'
    : '/game/figures/elf_Queen_Archer_face.png';
}

/**
 * Стиль «голова с короной и плечи»: спрайт нарисован в полный рост, в круг должна попасть ТОЛЬКО
 * верхняя часть — руки и оружие в портрете лишние (фидбек оунера 2026-07-29).
 *
 * Как считались числа: спрайт 256×256, нужная область — примерно y от 12 (верх короны) до 135
 * (низ плеч), то есть 5%…53% высоты. Масштаб = 100 / 48 ≈ 2.2, а точка привязки подбирается из
 * условия «верх области встаёт на верх круга»: origin = k·p / (k − 1) при p = 5% → ≈ 11%.
 */
export function mentorFace() {
  return { objectFit: 'cover', transform: 'scale(2.2)', transformOrigin: '50% 11%' };
}

// Совместимость со старым кодом (эмодзи-иконка) — используется там, где портрет не влезает.
export function mentorIcon(fraction) {
  return fraction === 'Zombie' ? '💀' : '🧝';
}

export default { mentorName, mentorIcon, mentorPortrait, mentorFace };
